// src/components/ProgrammesList.js

import React from 'react';
import './ProgrammesList.css';

import industryIcon from '../asset/industry management.png';
import businessIcon from '../asset/business manage.png';
import salesIcon from '../asset/sales.png';
import hrIcon from '../asset/hr.png';
import htIcon from '../asset/ht management.jpg';
import logisticIcon from '../asset/images.png';
import financeIcon from '../asset/finan.png';
import economicsIcon from '../asset/economics.png';
import purchaseIcon from '../asset/purchase.png';
import managerialIcon from '../asset/Managerial Information Management.png';
import itIcon from '../asset/it.jpeg';

const programmes = [
  { img: industryIcon, title: 'Industrial Management' },
  { img: businessIcon, title: 'Business Management' },
  { img: salesIcon, title: 'Sales Management' },
  { img: hrIcon, title: 'Human Resources Management' },
  { img: htIcon, title: 'Ht Management' },
  { img: logisticIcon, title: 'Logistic and Quality Management' },
  { img: financeIcon, title: 'Financial Management' },
  { img: economicsIcon, title: 'Economics Management' },
  { img: purchaseIcon, title: 'Purchase Management' },
  { img: managerialIcon, title: 'Managerial Information Management' },
  { img: itIcon, title: 'IT Industry' },
];

const ProgrammesList = () => {
  return (
    <div className="marque">
      <div className="Free">
        <div className="Contain">
          <h1>Wider Scope For Programmes<br /> as Follows</h1>
        </div>
      </div>
      {programmes.map((item, index) => (
        <div className="Section-div Wider" key={index}>
          <div className="section Sub-Wider">
            <img src={item.img} alt={item.title} />
          </div>
          <div className="material information">
            <h1>{item.title}</h1>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgrammesList;